<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="设备SN码" prop="clientSN">
        <Input
          v-model="editModel.clientSN"
          placeholder="设备SN码唯一"
          :disabled="true"
        ></Input>
      </FormItem>
      <FormItem label="设备名称" prop="clientName">
        <Input v-model="editModel.clientName"></Input>
      </FormItem>
      <FormItem label="设备类型" prop="clientType">
        <Input v-model="editModel.clientType"></Input>
      </FormItem>
      <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel = true">选择机构</Button>
        <span class="ml-5">{{ editModel.organName }}</span>
      </FormItem>
      <FormItem label="外网IP">
        <Input v-model="editModel.publicIp"></Input>
      </FormItem>
      <FormItem label="内网IP">
        <Input v-model="editModel.privateIp"></Input>
      </FormItem>
      <FormItem label="服务器用户名">
        <Input v-model="editModel.remoteUserName"></Input>
      </FormItem>

      
      <FormItem v-if="flag" label="服务器密码:" >
        <Row>
          <Col span="20">
            <Input
              type="password"
              placeholder
              v-model="editModel.remotePassword"
            >
            </Input>
          </Col>
          <Col span="4">
            <Icon
              @click="flag = !flag"
              type="ios-eye-off-outline"
              size="22"
            />
          </Col>
        </Row>
      </FormItem>
      <FormItem v-else label="服务器密码:" >
        <Row>
          <Col span="20">
            <Input type="text" placeholder v-model="editModel.remotePassword">
            </Input>
          </Col>
          <Col span="4">
            <Icon @click="flag = !flag" type="ios-eye-outline" size="22" />
          </Col>
        </Row>
      </FormItem>

      <FormItem label="数据库用户名">
        <Input v-model="editModel.dataBaseUserName"></Input>
      </FormItem>

      <FormItem v-if="dbflag" label="数据库密码:" prop="password">
        <Row>
          <Col span="20">
            <Input
              type="password"
              placeholder
              v-model="editModel.dataBasePassword"
            >
            </Input>
          </Col>
          <Col span="4">
            <Icon
              @click="dbflag = !dbflag"
              type="ios-eye-off-outline"
              size="22"
            />
          </Col>
        </Row>
      </FormItem>
      <FormItem v-else label="数据库密码:" prop="password">
        <Row>
          <Col span="20">
            <Input type="text" placeholder v-model="editModel.dataBasePassword">
            </Input>
          </Col>
          <Col span="4">
            <Icon @click="dbflag = !dbflag" type="ios-eye-outline" size="22" />
          </Col>
        </Row>
      </FormItem>
      <FormItem label="描述信息">
        <Input
          v-model="editModel.clientDescription"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>

    <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
export default {
  props: ["currentData"],
  components: { organTree },
  data: function () {
    return {
      flag: true,
      dbflag: true,
      treeModel: false,
      organParentName: "",
      editModel: {
        clientID: "",
        clientSN: "",
        clientName: "",
        clientType: "",
        clientDescription: "",
        organID: "",
        organName: "",
        publicIp: "",
        privateIp: "",
        remoteUserName: "",
        remotePassword: "",
        dataBaseUserName: "",
        dataBasePassword: "",
      },
      ruleValidate: {
        clientSN: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        organName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("client/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
    selectTreeData: function (data) {
      this.editModel.organID = data[0].organID;
      this.editModel.organName = data[0].title;
    },
  },
};
</script>
<style scoped>
</style>